export default class URLHelper {


  /**
   * Parses a query string and returns an object containing key-value pairs.
   *
   * @param {string} queryString - The query string to parse.
   * @return {Object} - An object containing the key-value pairs from the query string.
   */
  static parseQueryString(queryString) {
    // Remove leading '?' if present
    if (queryString.charAt(0) === '?') {
      queryString = queryString.substring(1);
    }

    // Split the query string into an array of key-value pairs
    let pairs = queryString.split('&');

    // Initialize an empty object to store the result
    let result = {};

    // Iterate over each key-value pair and populate the result object
    for (let i = 0; i < pairs.length; i++) {
      let pair = pairs[i].split('=');
      let key = decodeURIComponent(pair[0]);
      let value = decodeURIComponent(pair[1] || '');

      // If the key already exists, convert it to an array
      if (result.hasOwnProperty(key)) {
        if (!Array.isArray(result[key])) {
          result[key] = [result[key]];
        }
        result[key].push(value);
      } else {
        result[key] = value;
      }
    }

    return result;
  }

  /**
   * Returns the value of a specified query parameter from a given URL.
   * @param {string} url - The URL from which to extract the query parameter value.
   * @param {string} paramName - The name of the query parameter whose value is to be retrieved.
   * @return {string|null} - The value of the specified query parameter, or null if the query parameter does not exist.
   */
  static getParamValue(url, paramName) {
    if (url) {
      try {
        var encodedURL = encodeURI(url);
        var params = encodedURL.slice(encodedURL.indexOf('?') + 1).split('&');
        for (var i = 0; i < params.length; i++) {
          var paramPair = params[i].split('=');
          if (paramPair[0] === paramName) {
            return decodeURIComponent(paramPair[1]);
          }
        }
      } catch (e) {
        console.error("Malformed Button URL: ", url)
      }
    }
    return null;
  }

  static getFormularUID(url) {
    const match = url.match(/^formular:\/\/\{?([a-fA-F0-9-]+)\}?/);
    return match ? match[1] : null;
  }

  /**
   * Decodes HTML entities from a given input string.
   *
   * @param {string} html - The input string containing HTML entities to be decoded.
   * @return {string} - The decoded string without HTML entities.
   */
  static decodeHtml(html) {
    let txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  }

  static async readBlobAsJson(blob) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = function () {
        try {
          const json = JSON.parse(reader.result); // Blob-Inhalt als JSON parsen
          resolve(json);
        } catch (error) {
          reject(new Error("JSON Parsing Fehler: " + error.message)); // Fehler beim Parsen weitergeben
        }
      };

      reader.onerror = function () {
        reject(new Error("FileReader Fehler: Datei konnte nicht ausgelesen werden"));
      };

      reader.readAsText(blob); // Blob-Inhalt wird gelesen
    });
  }

  static getFilenameFromHeader(header) {
    const match = header.match(/filename="([^"]+)"/);
    if (match && match[1]) {
      return match[1];
    }
    return null;
  }
}
